module.exports = __webpack_public_path__ + "static/media/DEHAFEH_pathogene.8d9346fd.png";